import { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import Agenda from 'pages/SecuredArea/MainArea/Agenda';
import MaiaLogo from 'components/MaiaLogo';
import RegisterLayout from 'pages/RegisterLayout';
import sideImage from '_assets/register/calendar.svg';
import useStyles from './styles';

const steps = [
  [
    'Paramètrons votre agenda facilement et sans soucis !',
    'Définissons vos horaires d’ouverture en semaine',
    'Vous pourrez revenir dessus plus tard dans les préférences globales',
  ],
  [
    'Propageons cette semaine type sur une période pour faciliter la prise de rendez-vous des clients.',
    'Vous pourrez revenir et modifier cette semaine dans la partie agenda de votre interface',
  ],
];

function RegisterAgenda() {
  const classes = useStyles();
  const [step, setStep] = useState(0);

  const handleStepChange = (step) => {
    setStep(step);
  }

  const SideComponent = () => (
    <Grid container direction='column' style={{ height: 'auto' }}>
      <Grid container item justifyContent='center'>
        <MaiaLogo />
      </Grid>

      <Grid container item justifyContent='center' style={{ marginTop: '8vh' }}>
        <img src={sideImage} alt='Agenda' width={180} />
      </Grid>

      <Grid container item justifyContent='center' style={{ marginTop: '3vh' }}>
        {steps[step].map((text, index) => (
          <Typography key={index} className={classes.text} align='center' variant='h3'>
            {text}
          </Typography>
        ))}
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction='column' style={{ height: 'auto' }}>
        <Grid className={classes.header} container item justifyContent='center'>
          <Grid className={classes.title} container item xs={12} md={9} justifyContent='center'>
            <Typography variant='h1'>Configurer mon agenda</Typography>
          </Grid>
        </Grid>

        <Grid container item justifyContent='center' style={{ flexGrow: 1 }}>
          <Agenda config={true} register={true} onStepChange={handleStepChange} />
        </Grid>
      </Grid>
    </RegisterLayout>
  );
}

export default RegisterAgenda;
